<template lang="pug">
.left-wrapper
  //- .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(onclick='location.href='index-logged-in.html'')
  .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0
    .arrow-left
      i.fas.fa-chevron-left
    #back-home.modal-title.text-capitalize.pl-3 {{$t('ui.home')}}
  .left-menu
    .left-logo
      router-link(to="/")
        img.img-fluid(src='img/logo.png')
    .left-profile(v-if="$store.getters.isLoggedIn")
      .left-name
        //- .left-user
          img.img-fluid(src='img/icon-user.png')
        //- div Hi, 
          span.name-width {{getDisplayName}}
      .d-flex.justify-content-center.align-items-center.btn-balance(data-toggle='modal' data-target='#modal-deposit')
        .icon-plus
          i.fas.fa-plus-circle
        .left-balance
          .text-white.text-uppercase.text-balance {{$t('ui.balance')}}
          .balance-value {{ $numeral($store.getters.balance).format("0,0.00") }}
    .left-profile.d-block(v-else)
      .btn-login(data-toggle='modal' data-target='#modal-login') {{$t('ui.login')}}
    .menu-mobile
      ul.text-center.p-0.m-0
        //- li(v-if="$store.getters.isLoggedIn")
          a(href='#pills-profile' data-toggle='modal' data-target='#modal-profile')
            .menu-icon
              img(src='img/menu/profile.svg')
            .menu-text {{$tc('ui.profile')}}
        //- li
          a(href='#' data-toggle='modal' data-target='#modal-bankdetail')
            .menu-icon
              img(src='img/menu/bank.svg')
            .menu-text {{$tc('ui.bank_detail')}}
        li(v-if="$store.getters.isLoggedIn")
          a(href='#pills-changepw' data-toggle='modal' data-target='#modal-changepw')
            .menu-icon
              img(src='img/menu/changepw.svg')
            .menu-text {{$tc('ui.change_password')}}
        li(v-if="$store.getters.isLoggedIn")
          a(href='javascript:void(0)' data-toggle='modal' data-target='#modal-deposit')
            .menu-icon
              img(src='img/menu/deposit.svg')
            .menu-text {{$tc('ui.deposit')}}
        li(v-if="$store.getters.isLoggedIn")
          a(href='javascript:void(0)' data-toggle='modal' data-target='#modal-withdrawal')
            .menu-icon
              img(src='img/menu/withdrawal.svg')
            .menu-text {{$tc('ui.withdrawal')}}
        li(v-if="$store.getters.isLoggedIn")
          a(href="javascript:void(0)"  @click="redirect('/statement')")
            .menu-icon
              img(src='img/menu/statement.svg')
            .menu-text {{$tc('ui.statement')}} 
        //- li
          a(href='#')
            .menu-icon
              img(src='img/menu/download.svg')
            .menu-text {{$tc('ui.download')}}
        li(v-if="$store.getters.isLoggedIn && getPromoList.length > 0")
          a(href="javascript:void(0)"  @click="redirect('/promotions')")
            .menu-icon
              img(src='img/menu/promotions.svg')
            .menu-text {{$tc('ui.promotions')}}
        //- li
          a(href='#' data-toggle='modal' data-target='#modal-reward')
            .menu-icon
              img(src='img/menu/reward.svg')
            .menu-text rewards
        //- li
          a(href="javascript:void(0)"  @click="redirect('/contactUs')")
            .menu-icon
              img(src='img/menu/contact.svg')
            .menu-text {{$tc('ui.contactus')}}
        li(v-if="$store.getters.isLoggedIn")
          a(href="javascript:void(0)" @click="logout")
            .menu-icon
              img(src='img/menu/logout.svg')
            .menu-text {{$tc('ui.logout')}}
</template>
<script>
export default {
  computed:{
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    getPromoList(){
      return this.$store.getters.promoList.data.PROMOTION_LIST
    },
  },
  methods:{
    redirect(path){
      $('.overlay').hide();
      $('.left-wrapper').removeClass('d-block');
      $('body').removeClass("fixed");
      this.$router.push(path).catch(error =>{})
    },
    logout(){
      $('.overlay').hide();
      $('.left-wrapper').removeClass('d-block');
      $('body').removeClass("fixed");
      this.$store
        .dispatch("user/logout")
        .then(this.$router.push("/").catch(error =>{}))
        .catch(err => {})
      
    }
  }
}
</script>